import NativeAdsService from '@/api/admin/nativeAds.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
  },
  getters: {
    allNativeAds: state => state.table,
  },
  actions: {
    async getNativeAds({ commit }) {
      const nativeAds = await NativeAdsService.getNativeAds()
      commit('SET_NATIVE_ADS', nativeAds)
    },
  },
  mutations: {
    SET_NATIVE_ADS(state, nativeAds) {
      state.table.rows = nativeAds
    },
  },
}
